<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-form-model
      layout=""
      :model="formInline"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      @submit="handleSubmit"
      @submit.native.prevent
    >
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="结算周期">
            <a-input v-model="formInline.settlement" placeholder="请输入">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label=" " :colon="false">
            <span class="tips"
              >tips:结算周期是平台用户完成订单之后第N天方可提现</span
            >
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label=" " :colon="false">
            <a-button
              type="primary"
              @click="update"
              :style="{ margin: '0 0 24px 0' }"
            >
              更新
            </a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-table :columns="columns" :data-source="data" v-if="show"> </a-table>
  </div>
</template>

<script>
import { settlement, settlementEdit } from "@/api/homeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "Age",

    dataIndex: "name",
    key: "name",
    slots: { title: "customTitle" },
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Tags",
    key: "tags",
    dataIndex: "tags",
    scopedSlots: { customRender: "tags" },
  },
  {
    title: "Action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
];
// import chooseAnItem from "./chooseAnItem.vue";
export default {
  components: {
    // chooseAnItem,
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      formInline: {
        settlement: "",
      },
      data,
      columns,
      show: false,
    };
  },
  mounted() {
    this.getSettlement();
  },
  methods: {
    onChange(date, dateString) {
      console.log(date, dateString);
    },
    showtable(show) {
      this.show = show;
    },
    getSettlement() {
      settlement().then((res) => {
        this.formInline.settlement = res.data;
      });
    },
    update() {
      settlementEdit(this.formInline.settlement).then((res) => {
        message.success(res.info);
        this.getSettlement();
      });
    },
  },
};
</script>

<style scoped>
.tips {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/views/financialManagement/billingCycle/billingCycle.vue